import axiosInstance from './axiosConfig';

const API_URL = '/api/prices';

// Для калькулятора (завантажує ціни у форматі, зручному для розрахунків)
const getPublicPrices = () => {
 return axiosInstance.get(API_URL);
};

// Для адмін-панелі - отримуємо повний список цін з усіма деталями
const getAdminPrices = () => {
  return axiosInstance.get(`${API_URL}/admin`);
};

// Для адмін-панелі - оновлюємо ціни, надсилаючи масив об'єктів
const updateAdminPrices = (pricesArray) => {
  return axiosInstance.put(`${API_URL}/admin`, pricesArray);
};

const priceService = {
  getPublicPrices,
  getAdminPrices,
  updateAdminPrices,
};

export default priceService;